export const PROJECT_ROLE_LABELS = {
  MANAGER: "Manager",
  COLLABORATOR: "Collaborator",
  EXTERNAL_STAKEHOLDER: "Client Contact",
};

export const PROJECT_ROLE_OPTIONS = [
  { id: "MANAGER", name: PROJECT_ROLE_LABELS.MANAGER },
  { id: "COLLABORATOR", name: PROJECT_ROLE_LABELS.COLLABORATOR },
  { id: "EXTERNAL_STAKEHOLDER", name: PROJECT_ROLE_LABELS.EXTERNAL_STAKEHOLDER },
];
